import clientFailedSharesConstants from "../constants/clientFailedSharesConstants";

const initialState: {
    failedShares: any[] | null;
    pending: Boolean;
    error: Boolean;
} = {
    failedShares: null,
    pending: false,
    error: false,
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_REQUEST:
            return {
                ...state,
                pending: true,
                error: false,
            };
        case clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_SUCCESS:
            return {
                ...state,
                pending: false,
                failedShares: action.payload || [],
                error: false,
            };
        case clientFailedSharesConstants.GET_CLIENT_FAILED_SHARES_FAILURE:
            return {
                ...state,
                pending: false,
                error: true,
            };
        case clientFailedSharesConstants.RESET_CLIENT_FAILED_SHARES:
            return {
                ...state,
                failedShares: null,
                pending: false,
                error: false,
            };
        default:
            return state;
    }
};
